import { SORT_OPTIONS_ENUM } from 'src/constants'

export const getCDCSortOrderValueFromExpKey = (
  variant: string | undefined,
  currentSortValue: string,
) => {
  switch (variant) {
    case 'control':
      return SORT_OPTIONS_ENUM.RECOMMENDED
    case 'variant_a':
      return SORT_OPTIONS_ENUM.REVIEWS_DESCENDING
    default:
      return currentSortValue
  }
}

export const getHOSSortOrderValueFromExpKey = (
  variant: string | undefined,
  currentSortValue: string,
) => {
  switch (variant) {
    case 'control':
      return SORT_OPTIONS_ENUM.PRICE_ASCENDING
    case 'variant_a':
      return SORT_OPTIONS_ENUM.NO_SORT
    case 'variant_b':
      return SORT_OPTIONS_ENUM.REVIEWS_DESCENDING
    default:
      return currentSortValue
  }
}
